const formatDate = (value) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--';
  return date.toLocaleString('zh-CN', { hour12: false });
};

export const storeDeviceColumns = [
  {
    title: '设备 ID',
    dataIndex: 'id',
    key: 'id',
    render: (value) => value || '--',
  },
  {
    title: '设备名称',
    dataIndex: 'name',
    key: 'name',
    render: (value) => value || '--',
  },
  {
    title: '设备数量',
    dataIndex: 'num',
    key: 'num',
    render: (value) => value ?? '--',
  },
  {
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand',
    render: (value) => value || '--',
  },
  {
    title: '录入时间',
    dataIndex: 'ctime',
    key: 'ctime',
    render: formatDate,
  },
];
